var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScienceBottle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.68749 1.81065V5.14381C5.68749 5.31618 5.65355 5.48685 5.58759 5.64609C5.52163 5.80533 5.42495 5.95002 5.30307 6.0719L2.91666 8.45831M5.68749 1.81065C5.54107 1.82406 5.39524 1.83981 5.24999 1.85848M5.68749 1.81065C6.56061 1.72946 7.43938 1.72946 8.31249 1.81065M2.91666 8.45831L3.36582 8.34573C4.58674 8.04403 5.87522 8.18736 6.99999 8.74998C8.12477 9.31261 9.41324 9.45593 10.6342 9.15423L11.55 8.92498M2.91666 8.45831L1.63216 9.7434C0.912908 10.4615 1.25241 11.6783 2.25457 11.8492C3.79691 12.1129 5.38241 12.25 6.99999 12.25C8.59027 12.2505 10.1777 12.1165 11.7454 11.8492C12.747 11.6783 13.0865 10.4615 12.3678 9.74281L11.55 8.92498M8.31249 1.81065V5.14381C8.31249 5.49206 8.45074 5.82631 8.69691 6.0719L11.55 8.92498M8.31249 1.81065C8.45891 1.82406 8.60474 1.83981 8.74999 1.85848",
    stroke: "#555555",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScienceBottle);
export default __webpack_public_path__ + "static/media/ScienceBottle.43ea81461871b079ce2bce4ab59b1ebe.svg";
export { ForwardRef as ReactComponent };